import { useDeviceModeContext } from 'client/context/DeviceModeContext'
import { useSidebarVisibilityContext } from 'client/context/SidebarVisibilityContext'
import usePresentPage from 'client/hooks/usePresentPage'
import { getPageType } from 'client/reducers/pageReducer'
import { getMediaQueryByPageType } from 'common/constants/mediaQueries'
import React, { memo, PropsWithChildren } from 'react'
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import { ThemeProvider } from 'styled-components'
import { twMerge } from 'tailwind-merge'

export interface LayoutProps {
  isWebsitePreview?: boolean
}

export const Layout = memo(
  ({ children, isWebsitePreview = false }: PropsWithChildren<LayoutProps>) => {
    const isVisible = useSidebarVisibilityContext()
    const pageType = usePresentPage(getPageType)
    const { isMobile } = useDeviceModeContext()
    return (
      <ThemeProvider
        theme={{
          phone: getMediaQueryByPageType(pageType).phone,
          desktop: getMediaQueryByPageType(pageType).desktop,
          isEditorMobileMode: isMobile,
          isEditor: true,
        }}
      >
        {/* @ts-expect-error need to update react-dnd to be able to pass the children without an error: https://github.com/react-dnd/react-dnd/issues/3636#issuecomment-2246843871 */}
        <DndProvider backend={HTML5Backend}>
          <div
            className={twMerge(
              'grid h-screen grid-rows-[var(--layout-header-height)_auto]',
              isVisible ? 'grid-cols-[365px_1fr]' : 'grid-cols-[0_1fr]',
              isWebsitePreview && 'grid-cols-none',
            )}
          >
            {children}
          </div>
        </DndProvider>
      </ThemeProvider>
    )
  },
)
